import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CalendarEvent, CalendarEventTimesChangedEvent } from 'angular-calendar';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-custom-calendar-day-view',
  templateUrl: './custom-calendar-day-view.component.html'
})
export class CustomCalendarDayViewComponent {
  @Input() viewDate: Date;
  @Input() events: CalendarEvent[] = [];
  // Generated by Copilot- Start
  @Input() minimumEventCardWidth = 0;
  @Input() maximumEventCardWidth = 0;
  @Input() stickyBottomScrollbar = false;
  // Generated by Copilot- End
  @Input() hourSegments = 2;
  @Input() hourSegmentHeight = 30;
  @Input() hourDuration: number;
  @Input() minimumEventHeight = 30;
  @Input() dayStartHour = 0;
  @Input() dayStartMinute = 0;
  @Input() dayEndHour = 23;
  @Input() dayEndMinute = 59;
  @Input() refresh: Subject<any>;
  @Input() locale: string;
  @Input() eventSnapSize: number;
  @Input() tooltipPlacement: any = 'auto';
  @Input() tooltipTemplate: TemplateRef<any>;
  @Input() tooltipAppendToBody = true;
  @Input() tooltipDelay: number | null = null;
  @Input() hourSegmentTemplate: TemplateRef<any>;
  @Input() eventTemplate: TemplateRef<any>;
  @Input() eventTitleTemplate: TemplateRef<any>;
  @Input() eventActionsTemplate: TemplateRef<any>;
  @Input() snapDraggedEvents = true;
  @Input() allDayEventsLabelTemplate: TemplateRef<any>;
  @Input() currentTimeMarkerTemplate: TemplateRef<any>;
  @Input() validateEventTimesChanged: any;
  @Input() resizeCursors: any;

  @Output() eventClicked = new EventEmitter<any>();
  @Output() hourSegmentClicked = new EventEmitter<any>();
  @Output() eventTimesChanged = new EventEmitter<CalendarEventTimesChangedEvent>();
  @Output() beforeViewRender = new EventEmitter<any>();
}
